import { render } from "./FancyBox.vue?vue&type=template&id=c9defdf8"
import script from "./FancyBox.vue?vue&type=script&lang=js"
export * from "./FancyBox.vue?vue&type=script&lang=js"

import "@fancyapps/ui/dist/fancybox/fancybox.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__